import React from "react";
import { twMerge } from "tailwind-merge";

interface AddNewIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const AddNewIcon: React.FC<AddNewIconProps> = ({
  width = 40,
  height = 48,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 42"
      fill="none"
      className={twMerge(className, "text-foreground")}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_2184_4955)">
        <path
          d="M4.7384 6.83572C4.7384 3.48006 7.38337 0.759766 10.6461 0.759766H29.3538C32.6165 0.759766 35.2615 3.48006 35.2615 6.83572V33.1648C35.2615 36.5205 32.6165 39.2408 29.3538 39.2408H10.6461C7.38337 39.2408 4.7384 36.5205 4.7384 33.1648V6.83572Z"
          fill="none"
        />
      </g>
      <g filter="url(#filter1_di_2184_4955)">
        <path
          d="M9.97019 38.4365C10.1911 38.4661 10.4167 38.481 10.6462 38.481H11.426C11.8337 38.4812 12.1644 38.8212 12.1644 39.2405C12.1644 39.6599 11.8337 39.9998 11.426 40H10.6462C10.3526 40 10.063 39.9808 9.77885 39.9426C9.37459 39.8883 9.08971 39.507 9.14231 39.0912C9.19506 38.6752 9.56578 38.3823 9.97019 38.4365ZM16.1029 38.481C16.5106 38.4812 16.8413 38.8212 16.8413 39.2405C16.8413 39.6599 16.5106 39.9998 16.1029 40H14.5433C14.1356 39.9998 13.8048 39.6599 13.8048 39.2405C13.8048 38.8212 14.1356 38.4812 14.5433 38.481H16.1029ZM20.7798 38.481C21.1875 38.4812 21.5183 38.8212 21.5183 39.2405C21.5183 39.6599 21.1875 39.9998 20.7798 40H19.2202C18.8125 39.9998 18.4817 39.6599 18.4817 39.2405C18.4817 38.8212 18.8125 38.4812 19.2202 38.481H20.7798ZM25.4567 38.481C25.8644 38.4812 26.1952 38.8212 26.1952 39.2405C26.1952 39.6599 25.8644 39.9998 25.4567 40H23.8971C23.4894 39.9998 23.1587 39.6599 23.1587 39.2405C23.1587 38.8212 23.4894 38.4812 23.8971 38.481H25.4567ZM30.0298 38.4365C30.4342 38.3823 30.8049 38.6752 30.8577 39.0912C30.9103 39.507 30.6254 39.8883 30.2212 39.9426C29.937 39.9808 29.6474 40 29.3538 40H28.574C28.1663 39.9998 27.8356 39.6599 27.8356 39.2405C27.8356 38.8212 28.1663 38.4812 28.574 38.481H29.3538C29.5833 38.481 29.8089 38.4661 30.0298 38.4365ZM5.50865 36.2609C5.83191 36.0054 6.29565 36.0681 6.54423 36.4003C6.81962 36.7689 7.14163 37.1001 7.5 37.3833C7.82304 37.639 7.88398 38.1159 7.63558 38.4484C7.38716 38.7808 6.92335 38.843 6.6 38.5878C6.13985 38.2241 5.72668 37.7992 5.37308 37.326C5.12492 36.9934 5.18544 36.5164 5.50865 36.2609ZM33.4558 36.4003C33.7044 36.0681 34.1681 36.0054 34.4913 36.2609C34.8146 36.5164 34.8751 36.9934 34.6269 37.326C34.2733 37.7992 33.8601 38.2241 33.4 38.5878C33.0766 38.843 32.6128 38.7808 32.3644 38.4484C32.116 38.1159 32.177 37.639 32.5 37.3833C32.8584 37.1001 33.1804 36.7689 33.4558 36.4003ZM4 33.1646V32.4328C4.00023 32.0135 4.33076 31.6733 4.73846 31.6733C5.14616 31.6733 5.47669 32.0135 5.47692 32.4328V33.1646C5.47692 33.4005 5.49139 33.6326 5.52019 33.8598C5.57294 34.2757 5.28807 34.657 4.88365 34.7112C4.47938 34.7653 4.10858 34.4723 4.05577 34.0566C4.01871 33.7644 4 33.4665 4 33.1646ZM34.5231 33.1646V32.4328C34.5233 32.0135 34.8538 31.6733 35.2615 31.6733C35.6692 31.6733 35.9998 32.0135 36 32.4328V33.1646C36 33.4665 35.9813 33.7644 35.9442 34.0566C35.8914 34.4723 35.5206 34.7653 35.1163 34.7112C34.7119 34.657 34.4271 34.2757 34.4798 33.8598C34.5086 33.6326 34.5231 33.4005 34.5231 33.1646ZM4 29.5075V28.0449C4.00006 27.6255 4.33066 27.2854 4.73846 27.2854C5.14627 27.2854 5.47686 27.6255 5.47692 28.0449V29.5075C5.47692 29.927 5.1463 30.267 4.73846 30.267C4.33062 30.267 4 29.927 4 29.5075ZM34.5231 29.5075V28.0449C34.5231 27.6255 34.8537 27.2854 35.2615 27.2854C35.6693 27.2854 35.9999 27.6255 36 28.0449V29.5075C36 29.927 35.6694 30.267 35.2615 30.267C34.8537 30.267 34.5231 29.927 34.5231 29.5075ZM4 25.1197V23.657C4 23.2376 4.33062 22.8975 4.73846 22.8975C5.1463 22.8975 5.47692 23.2376 5.47692 23.657V25.1197C5.47686 25.5391 5.14627 25.8792 4.73846 25.8792C4.33066 25.8792 4.00006 25.5391 4 25.1197ZM34.5231 25.1197V23.657C34.5231 23.2376 34.8537 22.8975 35.2615 22.8975C35.6694 22.8975 36 23.2376 36 23.657V25.1197C35.9999 25.5391 35.6693 25.8792 35.2615 25.8792C34.8537 25.8792 34.5231 25.5391 34.5231 25.1197ZM4 20.7318V19.2682C4.00023 18.8489 4.33076 18.5087 4.73846 18.5087C5.14616 18.5087 5.47669 18.8489 5.47692 19.2682V20.7318C5.47669 21.1511 5.14616 21.4913 4.73846 21.4913C4.33076 21.4913 4.00023 21.1511 4 20.7318ZM34.5231 20.7318V19.2682C34.5233 18.8489 34.8538 18.5087 35.2615 18.5087C35.6692 18.5087 35.9998 18.8489 36 19.2682V20.7318C35.9998 21.1511 35.6692 21.4913 35.2615 21.4913C34.8538 21.4913 34.5233 21.1511 34.5231 20.7318ZM4 16.343V14.8803C4.00006 14.4609 4.33066 14.1208 4.73846 14.1208C5.14627 14.1208 5.47687 14.4609 5.47692 14.8803V16.343C5.47692 16.7624 5.1463 17.1025 4.73846 17.1025C4.33062 17.1025 4 16.7624 4 16.343ZM34.5231 16.343V14.8803C34.5231 14.4609 34.8537 14.1208 35.2615 14.1208C35.6693 14.1208 35.9999 14.4609 36 14.8803V16.343C36 16.7624 35.6694 17.1025 35.2615 17.1025C34.8537 17.1025 34.5231 16.7624 34.5231 16.343ZM4 11.9551V10.4925C4 10.073 4.33062 9.73299 4.73846 9.73299C5.1463 9.73299 5.47692 10.073 5.47692 10.4925V11.9551C5.47687 12.3745 5.14627 12.7146 4.73846 12.7146C4.33066 12.7146 4.00006 12.3745 4 11.9551ZM34.5231 11.9551V10.4925C34.5231 10.073 34.8537 9.73299 35.2615 9.73299C35.6694 9.73299 36 10.073 36 10.4925V11.9551C35.9999 12.3745 35.6693 12.7146 35.2615 12.7146C34.8537 12.7146 34.5231 12.3745 34.5231 11.9551ZM4 7.56725V6.83544C4 6.53354 4.01871 6.23565 4.05577 5.94343C4.10858 5.52766 4.47938 5.23467 4.88365 5.28877C5.28807 5.34302 5.57294 5.7243 5.52019 6.14023C5.49139 6.36741 5.47692 6.59948 5.47692 6.83544V7.56725C5.47669 7.9865 5.14616 8.32674 4.73846 8.32674C4.33076 8.32674 4.00023 7.9865 4 7.56725ZM34.5231 7.56725V6.83544C34.5231 6.59948 34.5086 6.36741 34.4798 6.14023C34.4271 5.7243 34.7119 5.34302 35.1163 5.28877C35.5206 5.23467 35.8914 5.52766 35.9442 5.94343C35.9813 6.23565 36 6.53354 36 6.83544V7.56725C35.9998 7.9865 35.6692 8.32674 35.2615 8.32674C34.8538 8.32674 34.5233 7.9865 34.5231 7.56725ZM6.6 1.41218C6.92335 1.15696 7.38716 1.2192 7.63558 1.55162C7.88398 1.88408 7.82304 2.36103 7.5 2.61669C7.14163 2.89993 6.81962 3.23111 6.54423 3.59968C6.29565 3.93193 5.83191 3.9946 5.50865 3.73912C5.18544 3.48363 5.12492 3.00661 5.37308 2.67405C5.72668 2.2008 6.13985 1.77586 6.6 1.41218ZM32.3644 1.55162C32.6128 1.2192 33.0766 1.15696 33.4 1.41218C33.8601 1.77586 34.2733 2.2008 34.6269 2.67405C34.8751 3.00661 34.8146 3.48363 34.4913 3.73912C34.1681 3.9946 33.7044 3.93193 33.4558 3.59968C33.1804 3.23111 32.8584 2.89993 32.5 2.61669C32.177 2.36103 32.116 1.88408 32.3644 1.55162ZM11.426 0C11.8337 0.000178509 12.1644 0.340147 12.1644 0.759494C12.1644 1.17884 11.8337 1.51881 11.426 1.51899H10.6462C10.4167 1.51899 10.1911 1.53386 9.97019 1.56349C9.56578 1.61774 9.19506 1.32475 9.14231 0.908821C9.08971 0.493037 9.37459 0.111671 9.77885 0.0573576C10.063 0.0192405 10.3526 0 10.6462 0H11.426ZM29.3538 0C29.6474 0 29.937 0.0192406 30.2212 0.0573576C30.6254 0.111671 30.9103 0.493038 30.8577 0.908821C30.8049 1.32475 30.4342 1.61774 30.0298 1.56349C29.8089 1.53386 29.5833 1.51899 29.3538 1.51899H28.574C28.1663 1.51881 27.8356 1.17884 27.8356 0.759494C27.8356 0.340147 28.1663 0.000178083 28.574 0H29.3538ZM16.1029 0C16.5106 0.000178509 16.8413 0.340147 16.8413 0.759494C16.8413 1.17884 16.5106 1.51881 16.1029 1.51899H14.5433C14.1356 1.51881 13.8048 1.17884 13.8048 0.759494C13.8048 0.340147 14.1356 0.000177889 14.5433 0H16.1029ZM20.7798 0C21.1875 0.000178509 21.5183 0.340147 21.5183 0.759494C21.5183 1.17884 21.1875 1.51881 20.7798 1.51899H19.2202C18.8125 1.51881 18.4817 1.17884 18.4817 0.759494C18.4817 0.340147 18.8125 0.000177889 19.2202 0H20.7798ZM25.4567 0C25.8644 0.000178199 26.1952 0.340147 26.1952 0.759494C26.1952 1.17884 25.8644 1.51881 25.4567 1.51899H23.8971C23.4894 1.51881 23.1587 1.17884 23.1587 0.759494C23.1587 0.340147 23.4894 0.000177889 23.8971 0H25.4567Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M14.5846 18.9851H24.4307M19.5079 13.9238V24.0504"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_di_2184_4955"
          x="0.738403"
          y="-0.240234"
          width="38.5231"
          height="47.4805"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2184_4955"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2184_4955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2184_4955"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="multiply"
            in2="shape"
            result="effect2_innerShadow_2184_4955"
          />
        </filter>
        <filter
          id="filter1_di_2184_4955"
          x="0"
          y="-1"
          width="40"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2184_4955"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2184_4955"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2184_4955"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="multiply"
            in2="shape"
            result="effect2_innerShadow_2184_4955"
          />
        </filter>
      </defs>
    </svg>
  );
};
